module.exports = __webpack_public_path__ + "img/nme-2.5e0bd2d0.png";